/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { OrganisationPaymentInfoBox_ViewerOrganisationFragmentDoc } from '../../features/organisations/boxes/OrganisationPaymentInfoBox.generated.js';
import { AccountingBox__OrganisationSettingsFragmentDoc, AccountingBox__OrganisationCountersFragmentDoc } from '../../features/organisations/boxes/OrganisationPaymentAccountingBox.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationPaymentQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrganisationPaymentQuery = { viewer?: { __typename: 'Viewer', id: string, organisation: { __typename: 'ViewerOrganisation', id: string, bankName: string, bankAccount: string, bankCode: string } } | null, organisationSettings: { __typename: 'OrganisationSetting', id: string, invoiceNumberMinLength: number, invoiceNumberPrefix: string, timeReportNumberMinLength: number, timeReportNumberPrefix: string, purchaseOrderNumberMinLength: number, purchaseOrderNumberPrefix: string, crmOrganisationNumberMinLength: number, crmOrganisationNumberPrefix: string, crmUserNumberMinLength: number, crmUserNumberPrefix: string, quoteNumberMinLength: number, quoteNumberPrefix: string, requirementNumberMinLength: number, requirementNumberPrefix: string }, organisationCounters: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationCounter', id: string, invoiceCounter: number, timeReportCounter: number, purchaseOrderCounter: number, crmOrganisationCounter: number, crmUserCounter: number, quoteCounter: number, requirementCounter: number } };


export const OrganisationPaymentDocument = gql`
    query OrganisationPayment {
  viewer {
    id
    organisation {
      id
      ...OrganisationPaymentInfoBox_ViewerOrganisation
    }
  }
  organisationSettings {
    id
    ...AccountingBox__OrganisationSettings
  }
  organisationCounters {
    ... on OrganisationCounter {
      id
      ...AccountingBox__OrganisationCounters
    }
  }
}
    ${OrganisationPaymentInfoBox_ViewerOrganisationFragmentDoc}
${AccountingBox__OrganisationSettingsFragmentDoc}
${AccountingBox__OrganisationCountersFragmentDoc}`;

/**
 * __useOrganisationPaymentQuery__
 *
 * To run a query within a React component, call `useOrganisationPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationPaymentQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationPaymentQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationPaymentQuery, OrganisationPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationPaymentQuery, OrganisationPaymentQueryVariables>(OrganisationPaymentDocument, options);
      }
export function useOrganisationPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationPaymentQuery, OrganisationPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationPaymentQuery, OrganisationPaymentQueryVariables>(OrganisationPaymentDocument, options);
        }
export function useOrganisationPaymentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationPaymentQuery, OrganisationPaymentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationPaymentQuery, OrganisationPaymentQueryVariables>(OrganisationPaymentDocument, options);
        }
export type OrganisationPaymentQueryHookResult = ReturnType<typeof useOrganisationPaymentQuery>;
export type OrganisationPaymentLazyQueryHookResult = ReturnType<typeof useOrganisationPaymentLazyQuery>;
export type OrganisationPaymentSuspenseQueryHookResult = ReturnType<typeof useOrganisationPaymentSuspenseQuery>;
export type OrganisationPaymentQueryResult = Apollo.QueryResult<OrganisationPaymentQuery, OrganisationPaymentQueryVariables>;